import CoContributorNoteDto from "../types/feedback/CoContributorNoteDto";

const NOTE_EDIT_WINDOW_MS = 24 * 60 * 60 * 1000;

export function canEditCoContributorNote(
  note: CoContributorNoteDto,
  loggedInUserId: number,
  now = Date.now(),
): boolean {
  if (note.authorUserId !== loggedInUserId) {
    return false;
  }

  const createdAt = new Date(note.dateCreated).getTime();
  if (Number.isNaN(createdAt)) {
    return false;
  }

  return now - createdAt <= NOTE_EDIT_WINDOW_MS;
}
